import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'percentFormat',
})
export class PercentFormatPipe implements PipeTransform {
	transform(value: number | null | undefined): string {
		if (value === null || value === undefined) {
			return '0%';
		}

		// Convert to percentage
		const percentValue = value * 100;
		const absPercentValue = Math.abs(percentValue);
		const sign = percentValue < 0 ? '-' : '';

		if (absPercentValue >= 1000000) {
			return sign + Math.floor(absPercentValue / 1000000) + 'M %';
		} else if (absPercentValue >= 1000) {
			return sign + Math.floor(absPercentValue / 1000) + 'k %';
		} else if (absPercentValue >= 100) {
			return sign + Math.floor(absPercentValue) + ' %';
		} else if (absPercentValue >= 10) {
			return sign + Math.floor(absPercentValue * 10) / 10 + ' %';
		} else {
			return sign + Math.floor(absPercentValue * 100) / 100 + ' %';
		}
	}
}
